import { Controller } from "stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ["select", "errorMessage", "assignedEmployees"]

  addEmployee(event) {
    const employeeId = event.target.value
    const employeeName = event.target.selectedOptions[0].text
    const taskId = this.element.dataset.taskId
    const date = this.element.dataset.date

    if (employeeId) {
      Rails.ajax({
        url: '/task_assignments',
        type: 'POST',
        data: `task_assignment[task_id]=${taskId}&task_assignment[employee_id]=${employeeId}&task_assignment[date]=${date}`,
        success: (response) => {
          this.assignedEmployeesTarget.insertAdjacentHTML('beforeend', `
            <span class="badge bg-primary me-1">
              ${response.employee_name}
              <a href="#" class="text-white ms-1" data-action="click->task-assignment#removeEmployee" data-employee-id="${response.employee_id}">&times;</a>
            </span>
          `)
          event.target.value = ""
          this.clearErrorMessage()
        },
        error: (xhr) => {
          const response = JSON.parse(xhr.response)
          this.showErrorMessage(response.errors.join(', '))
        }
      })
    }
  }

  removeEmployee(event) {
    event.preventDefault()
    const employeeId = event.target.dataset.employeeId
    const taskId = this.element.dataset.taskId
    const date = this.element.dataset.date

    Rails.ajax({
      url: `/task_assignments/${taskId}`,
      type: 'DELETE',
      data: `employee_id=${employeeId}&date=${date}`,
      success: (response) => {
        event.target.closest('.badge').remove()
        this.clearErrorMessage()
      },
      error: (xhr) => {
        const response = JSON.parse(xhr.response)
        this.showErrorMessage(response.message)
      }
    })
  }

  showErrorMessage(message) {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.textContent = message
      this.errorMessageTarget.classList.remove('d-none')
    } else {
      console.error(message)
    }
  }

  clearErrorMessage() {
    if (this.hasErrorMessageTarget) {
      this.errorMessageTarget.textContent = ''
      this.errorMessageTarget.classList.add('d-none')
    }
  }
}